import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { Provider } from 'react-redux'
import configureStore from './utilities/store'
import './i18n'
import './index.css'

const store = configureStore()

function renderApp() {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
  )
}

// Optional MSW worker for e2e — gated on VITE_E2E_MSW=on so normal
// `yarn start` pays zero cost. See src/mocks/browser.js + e2e/helpers/mockApi.ts.
if (import.meta.env?.VITE_E2E_MSW === 'on') {
  import('./mocks/browser')
    .then(({ worker }) => worker.start({ onUnhandledRequest: 'bypass' }))
    .then(renderApp)
    // eslint-disable-next-line no-console
    .catch((err) => {
      console.error('[MSW] failed to start; rendering without mocks', err)
      renderApp()
    })
} else {
  renderApp()
}

// Disable some logs on release
if (process.env.NODE_ENV !== 'development') {
  console.log = () => {}
  console.info = () => {}
}
